









































































import mixins from 'vue-typed-mixins';
import { User } from '@/utils/UserUtils';
import { DataTableHeader } from 'vuetify';
import cloneDeep from 'lodash.clonedeep';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => User,
    },
  },

  computed: {
    languages() {
      return [
        ...this.$locales?.map((locale) => ({
          text: this.$tc(`app.label.locale.${locale}`),
          value: locale,
        })),
      ];
    },
  },
});
